import React from 'react';
import { v4 as uuidv4 } from 'uuid';

import SkeletonBlock from '@components/common/Skeleton/SkeletonBlock';

import useTranslation from '@hooks/useTranslation';

import style from './style.module.scss';

const ShortDescriptionSkeleton = () => {
  const { t } = useTranslation();

  return (
    <div className={style.shortDescriptionWrapper}>
      <div className={style.blockHead}>
        <div className={style.blockTitle}>{t('Short Description')}</div>
      </div>
      <div className={style.shortDescription}>
        <div className={style.shortDescriptionHeader}>
          <div className={style.shortDescriptionHeaderItem}>{t('Component type')}</div>
          <div className={style.shortDescriptionHeaderItem}>{t('Fault Name')}</div>
          <div className={style.shortDescriptionHeaderItem}>{t('Recommendations')}</div>
          <div className={style.shortDescriptionHeaderItem}>{t("Fault's Severity")}</div>
        </div>
        <div className={style.shortDescriptionBody}>
          {[...Array(5)].map((_) => (
            <div key={uuidv4()} className={style.shortDescriptionBodyRow}>
              <SkeletonBlock className={style.skeletonShortDescriptionItem} />
              <SkeletonBlock className={style.skeletonShortDescriptionItem} />
              <SkeletonBlock className={style.skeletonShortDescriptionItem} />
              <SkeletonBlock className={style.skeletonShortDescriptionItem} />
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default ShortDescriptionSkeleton;
